import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider, ListItemGraphic } from 'rmwc/List';
import {default as Reactsel} from 'react-select';
import StarRatings from 'react-star-ratings';
import ReactTooltip from 'react-tooltip'

class TPOUserIndividualResource extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
            rating: '0.0',
            bookmarkStatus: '',
            existingRating: '',
            readStatus: '',
            elementView: '',
            errorMsg: '',
    		data:{
                tpoResourceId: ''
    		}
    	}
    }

    bookmarkResource = (e, nowBookmarkStatus) => {
        let bookmarkStatus
        let existingRating = Object.assign({}, this.state.existingRating)
        let readStatus
        let values = {
          'tpoResUserActivity':{
            'tpoResourceId' : this.props.tpoResourceId,
            'bookmarkStatus': nowBookmarkStatus
            }
          }
        api.userTPOActivity(this.props.user.accessToken, values)
        .then((result) => {
            if (result.status == 'success') {
                readStatus = result.data.read_status
                existingRating = result.data.rating
                bookmarkStatus = result.data.bookmark_status
                this.setState({readStatus: readStatus, existingRating: existingRating, bookmarkStatus: bookmarkStatus})
            }
        })
    }

    markAsRead = (e, nowReadStatus) => {
      let bookmarkStatus
      let elementView = Object.assign({}, this.state.elementView)
      let existingRating = Object.assign({}, this.state.existingRating)
      let readStatus
      let values = {
          'tpoResUserActivity':{
            'tpoResourceId' : this.props.tpoResourceId,
            'readStatus': nowReadStatus
          }
      }
      api.userTPOActivity(this.props.user.accessToken, values)
      .then((result) => {
          if (result.status == 'success') {
            readStatus = result.data.read_status
            existingRating = result.data.rating
            bookmarkStatus = result.data.bookmark_status
            this.setState({readStatus: readStatus, existingRating: existingRating, bookmarkStatus: bookmarkStatus})
          }
      }).catch((err) => {
            this.setState({ errorMsg: 'Error in updating User Activity.Please contact Admin.' })
        })
    }

    changeRating = (newRating) => {
        let bookmarkStatus
        let elementView = Object.assign({}, this.state.elementView)
        let existingRating = Object.assign({}, this.state.existingRating)
        let readStatus
        let values = {
          'tpoResUserActivity':{
            'tpoResourceId' : this.props.tpoResourceId,
            'rating' : newRating
          }
        }
        api.userTPOActivity(this.props.user.accessToken, values)
        .then((result) => {
            if (result.status == 'success') {
              elementView = 'already_rated'
              readStatus = result.data.read_status
              existingRating = result.data.rating
              bookmarkStatus = result.data.bookmark_status
              this.setState({readStatus: readStatus, existingRating: existingRating, elementView: elementView, bookmarkStatus: bookmarkStatus})
            }
        }).catch((err) => {
            this.setState({ errorMsg: 'Error in updating User Activity.Please contact Admin.' })
        })
    }

    componentDidMount(){
        let bookmarkStatus
        let data = Object.assign({}, this.state.data)
        data.tpoResourceId = this.props.tpoResourceId
        this.setState({data: data})
        let elementView = Object.assign({}, this.state.elementView)
        let readStatus
        let existingRating = Object.assign({}, this.state.existingRating)

        return api.userCheckPreviousTPORating(this.props.user.accessToken, this.props.tpoResourceId)
        .then((result) => {
            if(result.status == 'success') {
              if(result.data.rating == null) {
                elementView = 'not_rated'
                readStatus = result.data.read_status
                bookmarkStatus = result.data.bookmark_status
              }
              else {
                elementView = 'already_rated'
                existingRating = result.data.rating
                readStatus = result.data.read_status
                bookmarkStatus = result.data.bookmark_status
              }
            }
            else if(result.status == 'error') {
              elementView = 'not_rated'
            }
            this.setState({elementView: elementView, existingRating: existingRating, readStatus: readStatus, bookmarkStatus: bookmarkStatus})
        })
    }

    render(){
        let incomingComponent
        let readComponent
        let ratingComponent
        let markAsRead = this.markAsRead
        let rating
        let rateFloat = parseFloat(this.state.rating)
        let bookmarkComponent
        let bookmarkResource = this.bookmarkResource

        if(this.state.bookmarkStatus == '1') {
            let nowBookmarkStatus = 0
            bookmarkComponent = (
                <div>
                    <ListItemGraphic onClick= {((e) => bookmarkResource(e, nowBookmarkStatus))} style={{cursor: 'pointer'}} data-tip={'Remove Resource Bookmark'}>bookmark</ListItemGraphic>
                    <ReactTooltip place="top" type="dark" effect="solid"/>
                </div> 
            )   
        }else {
            let nowBookmarkStatus = 1
            bookmarkComponent = (
                <div>
                    <ListItemGraphic onClick= {((e) => bookmarkResource(e, nowBookmarkStatus))} style={{cursor: 'pointer'}} data-tip={'Bookmark Resource'}>bookmark_border</ListItemGraphic>
                    <ReactTooltip place="top" type="dark" effect="solid"/>
                </div>
            )
        }
        
        if(this.state.elementView == 'not_rated') {
            ratingComponent = (
                <StarRatings
                    rating={rateFloat}
                    starDimension="25px"
                    starSpacing="4px"
                    starRatedColor="wheat"
                    changeRating={this.changeRating}
                    numberOfStars={5}
                    name='rating'
                />
            )
        }
        else if (this.state.elementView == 'done_rating') {
            ratingComponent = (
                <Typography align = "left">Thank you. Your feedback is vital!</Typography>
            )
        }
        else if (this.state.elementView == 'already_rated') {
            let rateFloat = parseFloat(this.state.existingRating)
            ratingComponent = (
                <StarRatings
                    rating={rateFloat}
                    starDimension="25px"
                    starSpacing="4px"
                    starRatedColor="wheat"
                />
            )
        }

        if (this.state.readStatus == '1'){
            let nowReadStatus = 0
            readComponent = (
                <Button onClick= {((e) => markAsRead(e, nowReadStatus))}>Un Mark</Button>
            )
        }
        else {
            let nowReadStatus = 1
            readComponent = (
                <Button onClick= {((e) => markAsRead(e, nowReadStatus))}>Mark as Read</Button>
            )
        }
        return (
            <div>
                <Grid>
                    <GridCell span="3">
                       <Typography> {this.props.tpoResourceName} </Typography>
                    </GridCell>
                    <GridCell span="2">
                       <Typography> <a href={this.props.tpoResourceLink} target="_blank" style={{cursor: 'pointer'}}> View </a> </Typography>
                    </GridCell>
                    <GridCell span="3">
                        {readComponent}
                    </GridCell>
                    <GridCell span="4">
                        {ratingComponent}
                    </GridCell>
                    <GridCell span="3" className="grid-left-align">
                        <Typography align = "left"><i>Author: {this.props.tpoResourceAuthor}</i></Typography>
                    </GridCell>
                    <GridCell span="9" className="grid-left-align">
                        <Typography align = "left"><i>Description: {this.props.tpoResourceDescription}</i></Typography>
                    </GridCell>
                </Grid>
                <StatusMessage error_msg = {this.state.errorMsg} />
                <ListDivider />
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPOUserIndividualResource);



// WEBPACK FOOTER //
// ./src/views/roadmap/TPOUserIndividualResource.jsx